import { useTranslation } from "react-i18next";
import { InlineOtpAuth } from "@/components/auth/InlineOtpAuth";
import { AppointmentTicket, fmtKm, ticketPriceLabel } from "./AppointmentTicket";
import type { ServiceInfo } from "./types";
import type { PaymentMethodId } from "./PaymentStep";

export function BookingAuthStep({
  service, date, time, isBooking, onAuthenticated, paymentMethod,
  companyPayment, chargeAmount, modality, officeAddress,
}: {
  service: ServiceInfo;
  date: Date;
  time: string;
  isBooking: boolean;
  onAuthenticated: () => void;
  paymentMethod: PaymentMethodId;
  companyPayment?: { companyName: string; chargeAmount: number } | null;
  /** Server quote for card / bank transfer; ignored for company credit. */
  chargeAmount?: number | null;
  modality: "online" | "in_person";
  officeAddress?: string | null;
}) {
  const { t } = useTranslation();
  const isCompanyCredit = paymentMethod === "company_credit";
  const methodLabel =
    paymentMethod === "monri"
      ? t("booking.payCard")
      : paymentMethod === "bank_transfer"
        ? t("booking.payTransfer")
        : t("booking.payCompany");
  const priceLabel = ticketPriceLabel({ service, paymentMethod, companyPayment, chargeAmount });
  const companyLine =
    companyPayment
      ? t("booking.payCompanyConfirmLine", {
          companyName: companyPayment.companyName,
          amount: fmtKm(companyPayment.chargeAmount),
        })
      : null;

  const ticketProps = {
    service, date, time, methodLabel, priceLabel, companyLine,
    chargeAmount: isCompanyCredit ? null : chargeAmount,
    modality, officeAddress,
  };

  return (
    <InlineOtpAuth
      onAuthenticated={onAuthenticated}
      busy={isBooking}
      expandedSummary={<AppointmentTicket {...ticketProps} variant="full" />}
      compactSummary={<AppointmentTicket {...ticketProps} variant="slim" />}
    />
  );
}
